import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './DashboardInformation.module.css';
import { useDashboardInformation } from './useDashboardInformation';
import { InformationBlock } from './Blocks/InformationBlock/InformationBlock';
import { WeatherBlock } from './Blocks/WeatherBlock/WeatherBlock';
import { DocumentationBlock } from './Blocks/DocumentationBlock/DocumentationBlock';
import { VisualizationBlock } from './Blocks/VisualizationBlock/VisualizationBlock';
import { FinancialIndicatorsBlock } from './Blocks/FinancialIndicatorsBlock/FinancialIndicatorsBlock';
import { EstimatesBlock } from './Blocks/EstimatesBlock/EstimatesBlock';
import { ConstructionProgressBlock } from './Blocks/ConstructionProgressBlock/ConstructionProgressBlock';
import { Skeleton } from '../../components/newUI/Skeleton/Skeleton';

interface DashboardInformationProps {
    classes?: string;
}

export const DashboardInformation = memo(({ classes }: DashboardInformationProps) => {
    const { isLoading, can_show_financial_info, is_customer, tabs } = useDashboardInformation();

    return (
        <div
            className={classNames(
                cls.DashboardInformation,
                {
                    [cls.notTabs]: !tabs.show,
                },
                [classes]
            )}
        >
            <div className={cls.firstRow} data-hint-target="dashboard-info-2-target">
                {!isLoading ? <InformationBlock /> : <Skeleton height={300} border={'8px'} />}
                <div className={cls.firstRowChild}>
                    {!isLoading ? <WeatherBlock /> : <Skeleton height={168} border={'8px'} />}
                    {!isLoading ? (
                        <>{can_show_financial_info && !is_customer && <DocumentationBlock />}</>
                    ) : (
                        <Skeleton height={116} border={'8px'} />
                    )}
                </div>
                {!isLoading ? <VisualizationBlock /> : <Skeleton height={300} border={'8px'} />}
            </div>
            {(can_show_financial_info || is_customer) && (
                <div className={cls.SecondRow}>
                    {!isLoading ? (
                        <FinancialIndicatorsBlock />
                    ) : (
                        <Skeleton height={332} border={'8px'} />
                    )}
                    {!isLoading ? <EstimatesBlock /> : <Skeleton height={332} border={'8px'} />}
                </div>
            )}
            <div className={cls.ThirdRow}>
                {!isLoading ? (
                    <ConstructionProgressBlock />
                ) : (
                    <Skeleton height={228} border={'8px'} />
                )}
            </div>
        </div>
    );
});
